export const LINKS = {
  LOGIN: "/login",
  HOME: "/",
  ETHEREUM: "/monsterzone",
  CARDANO: "/monsterzone/cardano",
};
